
/**
 * 정렬 정보
 */
export type GetCourseDrafts200PageableSort = {
  /** 빈 정렬 여부 */
  empty?: boolean;
  /** 정렬 여부 */
  sorted?: boolean;
  /** 정렬 안 함 여부 */
  unsorted?: boolean;
};
